import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { generalIcons, text } from "../../utils/constants";
import { WalletOptions } from "../connectWallet/WalletOptions";

function ConnectWalletModal({ isToggled, setToggled }) {
  const bodyElement = document.body;
  isToggled
    ? bodyElement.classList.add("overflow-hidden")
    : bodyElement.classList.remove("overflow-hidden");

  return (
    <AnimatePresence>
      {isToggled && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed top-0 left-0 w-screen h-screen bg-vampireBlack/90 z-50 overflow-y-auto overflow-x-hidden flex"
        >
          <div className="flex items-center justify-center w-full h-auto xsm:h-full px-4 forMobile">
            <motion.div
              initial={{
                opacity: 0,
                scale: 0,
                transition: {
                  duration: 0.3,
                },
              }}
              animate={{
                opacity: 1,
                scale: 1,
                transition: {
                  duration: 0.3,
                  mass: 0.8,
                  type: "spring",
                },
              }}
              exit={{
                opacity: 0,
                scale: 0,
                transition: {
                  duration: 0.3,
                },
              }}
              className="max-w-[680px] w-full bg-[#FCFCFC] rounded-3xl p-5 lg:p-8 mx-auto my-5"
            >
              <div className="flex items-center justify-between gap-2">
                <h4 className="text-black text-xl md:text-xxl font-bold -tracking-09">
                  Connect your wallet
                </h4>

                <button
                  className="w-6 h-6 md:w-8 md:h-8 flex items-center justify-center cursor-pointer"
                  onClick={() => setToggled(!isToggled)}
                >
                  {generalIcons.arrow_Wallet_Modal}
                </button>
              </div>

              <p className="text-xsm md:text-sm font-medium text-vampireBlack/70 -tracking-04 mt-3 md:mt-4">
                {text.WALLET}
              </p>

              <ul className="mt-5 md:mt-8 space-y-3">
                <WalletOptions iconCustomClass="mr-3 lg:mr-4 w-6 h-6 md:w-8 md:h-8"/>
              </ul>
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default ConnectWalletModal;
